import { render, staticRenderFns } from "./grayScaleTestAdd.vue?vue&type=template&id=0a5a36a3&scoped=true&"
import script from "./grayScaleTestAdd.vue?vue&type=script&lang=js&"
export * from "./grayScaleTestAdd.vue?vue&type=script&lang=js&"
import style0 from "./grayScaleTestAdd.vue?vue&type=style&index=0&id=0a5a36a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a36a3",
  null
  
)

export default component.exports